// extracted by mini-css-extract-plugin
export default {"zone":"UB1eTB0b","leftArrow":"E_94jxeQ","gallery":"gallery","rightArrow":"_ZUFTnf_","fullscreen":"zs9s1DCQ","disabledZone":"GAeemxKA"};